export default __webpack_public_path__ + "media/images/rolling-33ea73f2310482982f9c5afe88d3f048.svg";